import React, { useState, useEffect } from 'react'
import BannerCard from './BannerCard'
import './styles.css'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllBanners } from '../../../redux/bannerSlice'
import { useNavigate } from 'react-router-dom'
import PaginationCard from '../../../components/Table/PaginationCard'
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined'

const BannerContent = () => {
  const dispatch = useDispatch()
  const banners = useSelector(state => state.banners)
  const navigate = useNavigate()
  const [deleted, setIsDeleted] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(0); // Reset to the first page when page size changes
  };
  const handleEditBanner = () => {
    navigate(`../banner/add`)
  }
  useEffect(() => {
    const queryParams = {
      searchText: '',
      pageSize: pageSize, // Use state value
      pageNumber: pageNumber, // Use state value
    };
    dispatch(fetchAllBanners(queryParams));
  }, [pageNumber, pageSize, deleted])

  if (banners.loading) {
    return <div>
      Loading
    </div>
  }

  return (
    <div>
      <button className="btn btn-primary greeen-btn md_btn" style={{ marginBottom: '10px' }} onClick={handleEditBanner}>
        <span><ControlPointOutlinedIcon /></span> Create Banner
      </button>

      <div className='banner_container'>
        {banners.data.length == 0 ? <div>
          No Banners Found
        </div> : banners.data.map((banner) => (
          <div key={banner.bannerId}>
            <BannerCard banner={banner} isDeleted={deleted} setIsDeleted={setIsDeleted} />
          </div>
        ))}
      </div>
      <PaginationCard
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={banners.totalRecords}
      />
    </div>
  )
}

export default BannerContent